function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class DataNetworkError extends Error {
    constructor(message, status, requestId){
        super(message);
        _define_property(this, "extensions", void 0);
        this.message = message;
        this.extensions = {
            actionId: null,
            traceId: null,
            unstable_requestId: requestId,
            error: {
                code: 'network_error',
                status
            }
        };
    }
}
export { DataNetworkError as default };

//# sourceMappingURL=DataNetworkError.js.map